import { Component, Inject, ViewChild } from '@angular/core';
import { DialogeComponent } from '../dialoge/dialoge.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { SharedService } from '../../Services/shared.service';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { BaseComponent } from '../base/base.component';
import { MatPaginator } from '@angular/material/paginator';
import { ValidationService } from '../../Services/validation.service';
import { LoggingService } from '../../Services/NGLogger/logging-service.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-lookup-location',
  templateUrl: './lookup-location.component.html',
  styleUrls: ['./lookup-location.component.css']
})
export class LookupLocationComponent extends BaseComponent {
  @ViewChild(MatPaginator, { static: false }) paginators!: MatPaginator;
  LocationListData: any = [];
  countries!: any[];
  counties!: any[];
  States!: any[];
  City!: any[];
  SearchValue: string = "";
  isSearch: boolean = false;
  TabIndex: number = 0;
  Operation: string = "Add New Location";
  StateLoader = false;
  CityLoader = false;
  originalCountryList: any;
  originalstateList: any;
  originalcityList: any;
  formGroup!: FormGroup;
  Submitted: any;
  locationId: number = 0;
  override showloader: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<LookupLocationComponent>,
    private sharedService: SharedService,
    private Dilog: MatDialog,
    private datePipe: DatePipe,
    private validationService: ValidationService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private loggingService: LoggingService
  ) {
    super();
    this.formInit();
  }

  override ngOnInit(): void {
    this.LoadListData();
    this.GetCountryList()
  }

  formInit() {
    this.formGroup = this.fb.group({
      id: [0],
      locationCode: ["Auto generated"],
      locationName: ["", [Validators.required]],
      addressLine1: [""],
      addressLine2: [""],
      city: ["", [Validators.required]],
      county: [''],
      stateId: ['', [Validators.required]],
      zipCode: [""],
      countryId: ['', [Validators.required]],
      longitude: [0, this.decimalValidator(12, 8)],
      latitude: [0, this.decimalValidator(12, 8)],
      description: [""],
      createdBy: [0],
      modifiedBy: [0],
      isActive: [true],
      epId: [this.dialogData?.EpId]
    });
  }
  restrictInput(event: KeyboardEvent): void {
    this.validationService.restrictSpecialInput(event);
  }

  changeTab(event: any) {
    if (event.index === 0) {
      this.formGroup.patchValue({
        id: 0,
        locationCode: "",
        locationName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        stateId: '',
        county: '',
        zipCode: "",
        countryId: "",
        description: "",
        latitude: 0,
        longitude: 0,
        createdBy: 0,
        modifiedBy: 0,
        isActive: true,
        epId: this.dialogData?.EpId
      });
    }
    if (event.index == 0) {

      this.Operation = "Add New Location";
    }
    this.Submitted = false;
    this.TabIndex = event.index;
  }

  onPopupClose() {
    this.dialogRef.close('popClose');
  }

  gotoBack() {
    this.Operation = "Add New Location";
    this.TabIndex = 0;
  }

  clearSearchField() {
    this.SearchValue = "";
    this.LoadListData();
  }

  Select(data: any) {
    const selectedCountry = this.countries.find((country: any) => country.countryId === data.countryId);
    if (selectedCountry) {
      data.selectedCountry = selectedCountry;
    }
    this.dialogRef.close(data);
  }

  clickMethod(item: any) {
    let jobid = item.jobId;
    const dialogRef = this.Dilog.open(DialogeComponent, {
      width: '30%',
      maxHeight: '90%',
      panelClass: 'modal-matdelete',
      data: {
        "title": "Warning!",
        "prefix":"Are you sure you want to delete ",
        "message": (item?.locationName != null ? item?.locationName : "") + "?"
      },
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data.event == 'Yes') {
        this.Delete(item)
      }
    })
  }

  GetCountryList() {
    this.sharedService.GetEPLocationByID(0).subscribe((res: any) => {
      if (res) {
        this.countries = res?.data.countries;
        this.originalCountryList = this.countries;
        this.States = res?.data.states
        this.originalstateList = this.States;
      }
    },
      err => { this.loggingService.captureException(err); }
    );
  }

  async Edit(data: any) {
    try {
      const res: any = await firstValueFrom(this.sharedService.GetEPLocationByID(data.id));
      if (res) {
      this.TabIndex = 1;
        this.countries = res?.data.countries;
        this.States = res?.data.states;
        this.formGroup.patchValue({
          id: data.id,
          locationCode: res?.data.locationCode,
          locationName: res?.data.locationName,
          addressLine1: res?.data.addressLine1,
          addressLine2: res?.data.addressLine2,
          zipCode: res?.data.zipCode,
          description: res?.data.description,
          createdBy: res?.data.createdBy,
          latitude: res?.data.latitude,
          longitude: res?.data.longitude
        });
        await this.SelectAddresss(res?.data.countryId,res?.data.stateId,res?.data.city);
        this.locationId = data.id;
        this.Operation = "Update Location";
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

 async SelectAddresss(countryId: any, stateId: any, cityName: any){
    const selectedCountry = this.countries.find((country: any) => country.countryId === countryId);
        if (selectedCountry) {
          this.formGroup.controls['countryId'].setValue(selectedCountry);
        }
        else {
          this.formGroup.controls['countryId'].setValue(null);
        }
        if (selectedCountry) {
          const selectedState = this.States.find((state: any) => state.stateId === stateId);
          if (selectedState) {
            this.formGroup.controls['stateId'].setValue(selectedState);
            if (selectedState) {
              await this.LoadCityData();
              const selectedCity = this.City.find((city: any) => city.cityName === cityName);
              if (selectedCity) {
                this.formGroup.controls['city'].setValue(selectedCity);
              }
              else {
                this.formGroup.controls['city'].setValue(null);
              }
            }
          }
          else {
            this.formGroup.controls['stateId'].setValue(null);
          }
        }
  }
  async Delete(data: any) {
    try {
      const res: any = await firstValueFrom(this.sharedService.DeleteEPLocation(data.id));
      if (res) {
        if (res.succeeded) {
          this.showToastr(res?.messages[0]);
          this.LoadListData();
        } else {
          this.showToastr(res?.messages[0], 'error');
        }
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }
  async onSubmit() {
    this.Submitted = true;
    const savValue = JSON.parse(JSON.stringify(this.formGroup.value));
    this.copyFormValues(this.formGroup, this.formGroup, [
      { sourceControlName: 'countryId', targetControlName: 'countryId', nestedKey: 'countryId' },
      { sourceControlName: 'stateId', targetControlName: 'stateId', nestedKey: 'stateId' },
      { sourceControlName: 'city', targetControlName: 'city', nestedKey: 'cityName' }
    ]);
    if (this.formGroup.valid) {
      try {
        const res: any = await firstValueFrom(this.sharedService.addUpdateEPLocation(this.formGroup.value));
        if (res) {
          if (res.succeeded) {
            this.showToastr(res?.messages[0]);
            this.LoadListData();
            this.TabIndex = 0;
            this.Submitted = false;
          } else {
            this.formGroup.patchValue(savValue);
            const concatenatedMessage = res?.messages?.map((msg: any) => msg).join('\n');
            this.showToastr(concatenatedMessage, 'error');
          }
        }
      } catch (err) {
        this.loggingService.captureException(err);
      }
    }
    else{
      this.formGroup.patchValue(savValue);
    }
  }

  async LoadListData() {
    const SearchData = this.SearchValue == "" ? "All" : this.SearchValue;
    const searchVm = {
      Search: SearchData,
      PageSize: this.Paginator.PageSize,
      PageNumber: this.Paginator.PageIndex + 1,
      EpId: this.dialogData?.EpId
    };

    try {
      const res: any = await firstValueFrom(this.sharedService.getEPLocationList(searchVm));
      if (res) {
        this.LocationListData = res?.data?.items;
        this.Paginator.Length = this.LocationListData.length > 0 ? res?.data?.totalRecords : 0;
        if (this.isSearch) {
          if (this.paginators != undefined) {
            this.paginators.pageIndex = 0;
          }
        }
        this.isSearch = false;
        this.showloader = false;
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  async LoadStateData() {
    this.StateLoader = true;
    try {
      const res: any = await firstValueFrom(this.sharedService.LoadAllState(parseInt(this.formGroup.controls['countryId'].value?.countryId)));
      if (res) {
        this.States = res?.data;
        this.originalstateList = this.States;
        this.StateLoader = false;
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  async LoadCityData() {
    this.CityLoader = true;
    try {
      const res: any = await firstValueFrom(this.sharedService.LoadAllCity(
        parseInt(this.formGroup.controls['countryId'].value?.countryId),
        parseInt(this.formGroup.controls['stateId'].value?.stateId)
      ));
      if (res) {
        this.City = res?.data;
        this.originalcityList = this.City;
        this.CityLoader = false;
      }
    } catch (err) {
      this.loggingService.captureException(err);
    }
  }

  OnBlankInput(e: any) {
    if (e.target.value == '' || e.target.value == null) {
      this.LoadListData();
    }
  }

  setPagination(e: any) {
    this.Paginator.PageSize = e.pageSize;
    this.Paginator.PageIndex = e.pageIndex;
    this.LoadListData();
  }

  onSearch() {
    this.isSearch = true;
    this.showloader = true;
    this.Paginator.PageIndex = 0;
    this.LoadListData();
  }
  omitSpecialChar(event: KeyboardEvent): void {
    const isValid = this.validationService.omitValidateSpecialChar(event);
    if (!isValid) {
      event.preventDefault();
    }
  }
  removeSpaces(e: any) {
    this.validationService.removeSpaces(e);
  }

  omitValidateSpecialChar(event: any) {
    const isValid = this.validationService.omitValidateSpecialChar(event);
    if (!isValid) {
      event.preventDefault();
    }
  }
  omitSpecialCharNumber(event: any) {
    this.validationService.omitSpecialCharNumber(event);
  }

  filterCountry(event: any) {
    const searchValue = event.target.value.toLowerCase();
    this.countries = this.originalCountryList.filter((item: any) => {
      return item.countryName.toLowerCase().includes(searchValue);
    });
    this.noData = this.countries.length === 0 && searchValue?.trim().length > 0;
  }

  filterState(event: any) {
    this.States = this.sharedService.filterList(
      this.States,
      this.originalstateList,
      event.target.value,
      'stateName'
    );
    this.noData = this.States.length === 0 && event.target.value?.trim().length > 0;
  }

  filterCity(event: any) {
    this.City = this.sharedService.filterList(
      this.City,
      this.originalcityList,
      event.target.value,
      'cityName'
    );
    this.noData = this.City.length === 0 && event.target.value?.trim().length > 0;
  }

  onOptionSelectedCountry(event: any) {
    const selectedOption = this.countries.find(option => option.countryId === event.option.id);
    if (selectedOption) {
      this.formGroup.controls['countryId'].setValue(selectedOption);
    }
  }

  onOptionSelectedState(event: any) {
    const selectedOption = this.States.find(option => option.stateId === event.option.id);
    if (selectedOption) {
      this.formGroup.controls['stateId'].setValue(selectedOption);
      this.LoadCityData();
    }
  }

  onOptionSelectedCity(event: any) {
    const selectedOption = this.City.find(option => option.cityName === event.option.id);
    if (selectedOption) {
      this.formGroup.controls['city'].setValue(selectedOption);
    }
  }

  getStateNameById(stateId: string): string {
    return this.sharedService.getStateNameById(this.States, stateId);
  }

  getCountryNameById(countryId: string): string {
    return this.sharedService.getCountryNameById(this.countries, countryId);
  }

  onInputChange(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.value === '') {
      this.onSearch();
    }
  }

  // Custom validator for decimal values
  decimalValidator(maxDigits: number, decimalPlaces: number) {
    return (control: any) => {
      const value = control.value;

      // Only validate if there is a value entered
      if (value) {
        const regex = new RegExp(`^-?\\d{1,${maxDigits - decimalPlaces}}(\\.\\d{0,${decimalPlaces}})?$`);
        if (!regex.test(value)) {
          return { invalidDecimal: true }; // Invalid format
        }
      }
      return null; // Valid or empty
    };
  }

  clearCountry(){
    if ((this.formGroup.controls['countryId'].value == "" || this.formGroup.controls['countryId'].value == null) && this.formGroup.controls['countryName'].value !== "") {
      this.formGroup.controls['countryName'].setValue(null);
      this.formGroup.controls['stateName'].setValue(null);
      this.formGroup.controls['stateId'].setValue(null);
      this.formGroup.controls['city'].setValue(null);
    }
  }

  clearState(){
    if ((this.formGroup.controls['stateId'].value == "" || this.formGroup.controls['stateId'].value == null) && this.formGroup.controls['stateName'].value !== "") {
      this.formGroup.controls['stateName'].setValue(null);
      this.formGroup.controls['city'].setValue(null);
    }
  }

  clearCity(event:Event){
    const value = (event.target as HTMLInputElement).value;
    const checkCity:any={} = this.City.filter((city:any) => city.cityName.toLowerCase()===(value.toLowerCase()));
    if(checkCity.length <= 0){
      this.formGroup.controls['city'].setValue(null);
    }
  }

  handlePaste(event: ClipboardEvent): void {
    this.handlePasteEvent(event, (text) => this.validationService.omitValidateSpecialCharString(text) as string);
  }

  handleZipCodePaste(event: ClipboardEvent): void {
    this.handlePasteEvent(event, (text) => this.validationService.allowAlphaNumeric(text) as string, 10);
  }

  handleClosed(filteredArray: any, originalList: any, form: FormGroup, controlName: string, displayName: string) {
    this.onClosedCallback(filteredArray, originalList, form, controlName, displayName);
    this.onCountryEvents();
  }

  onCountryEvents() {
    if(this.formGroup.get('countryId')?.value != null && typeof this.formGroup.get('countryId')?.value == 'object'){
      this.formGroup.controls['stateId'].setValue(null);
      this.formGroup.controls['city'].setValue(null);
      this.City = [];
      this.StateLoader = true;
      this.LoadStateData();
    }
    else{
      this.resetCountryAndStates();
    }
  }

    private resetCountryAndStates(): void {
      this.formGroup.controls['countryId'].setValue(null);
      this.formGroup.controls['stateId'].setValue(null);
      this.formGroup.controls['city'].setValue(null);
      this.countries = this.originalCountryList;
      this.States = [];
      this.City = [];
  }

  handleStateClosed(filteredArray: any, originalList: any, form: FormGroup, controlName: string, displayName: string) {
    this.onClosedCallback(filteredArray, originalList, form, controlName, displayName);
    this.onStateEvent();
  }

  onStateEvent(){
    if(this.formGroup.get('stateId')?.value != null && typeof this.formGroup.get('stateId')?.value == 'object'){
      this.formGroup.controls['city'].setValue(null);
      this.CityLoader = true;
      this.LoadCityData();
    }
    else{
      this.formGroup.controls['city'].setValue(null);
      this.States = this.originalstateList;
      this.City = [];
    }
  }
}
